import { render, staticRenderFns } from "./FormularioCadastroTipoCotas.vue?vue&type=template&id=a0051b7a&"
import script from "./FormularioCadastroTipoCotas.vue?vue&type=script&lang=js&"
export * from "./FormularioCadastroTipoCotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports